import React, { useState, useRef } from 'react';
import { Html5QrcodeScanner } from 'html5-qrcode';
import { FiX } from 'react-icons/fi';

const QRScanner = ({ onScan, onClose }) => {
  const [scanResult, setScanResult] = useState(null);
  const scannerRef = useRef(null);

  React.useEffect(() => {
    const scanner = new Html5QrcodeScanner(
      'qr-scanner-element',
      {
        fps: 10,
        qrbox: { width: 250, height: 250 },
        aspectRatio: 1.0,
        showTorchButtonIfSupported: true,
        disableFlip: false,
      },
      false
    );

    scanner.render(
      (decodedText) => {
        setScanResult(decodedText);
        scanner.clear();
        onScan?.(decodedText);
      },
      (error) => {
        console.log('QR Error:', error);
      }
    );

    scannerRef.current = scanner;

    return () => {
      try {
        scanner.clear();
      } catch (error) {
        console.error('Scanner cleanup error:', error);
      }
    };
  }, [onScan]);

  return (
    <div style={{ position: 'relative' }}>
      <button
        onClick={onClose}
        className="modal-close"
        style={{ position: 'absolute', top: '1rem', right: '1rem', zIndex: 10 }}
      >
        <FiX size={24} color="#fff" />
      </button>

      <div
        id="qr-scanner-element"
        style={{
          width: '100%',
          borderRadius: '12px',
          overflow: 'hidden',
          backgroundColor: '#000',
        }}
      ></div>

      {scanResult && (
        <div className="qr-result">
          <h4>Code QR détecté</h4>
          <p style={{ fontSize: '0.875rem', wordBreak: 'break-all' }}>{scanResult}</p>
        </div>
      )}
    </div>
  );
};

export default QRScanner;
